module.exports = __webpack_public_path__ + "img/panasonic_001_thumb.c548d0c5.jpg";